@if (renderPanel()) {
<div
  role="tabpanel"
  [id]="'panel-' + id()"
  [attr.aria-labelledby]="'tab-' + id()"
  [hidden]="!active()"
  [attr.aria-hidden]="!active()"
  class="tab-content"
>
  <ng-content></ng-content>
</div>
}
